export enum ETimeFrequency {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  CUSTOM = 'CUSTOM',
  ONCE = 'ONCE',
  ON_REQUEST = 'ON_REQUEST',
}

export enum EFileType {
  PDF = 'pdf',
  DOCX = 'docx',
  PPTX = 'pptx',
  PPSX = 'ppsx',
  CSV = 'csv',
  IMAGE = 'image',
  JPEG = 'jpeg',
  PNG = 'png',
  XLSX = 'xlsx',
  ZIP = 'zip',
  HTML = 'html',
}

export enum EScheduleType {
  REPORT = 'Report',
  EXPORT = 'Export',
  EXCEL_REPORT = 'Excel report',
  POWERPOINT_REPORT = 'Powerpoint report',
}

export enum EMimeType {
  PDF = 'application/pdf',
  CSV = 'text/csv',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  PPSX = 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  ZIP = 'application/zip',
  HTML = 'text/html',
}

export const MIME_TYPE_TO_FILE_EXTENSION: Record<EMimeType, `.${EFileType}`> = {
  [EMimeType.PDF]: `.${EFileType.PDF}`,
  [EMimeType.CSV]: `.${EFileType.CSV}`,
  [EMimeType.XLSX]: `.${EFileType.XLSX}`,
  [EMimeType.DOCX]: `.${EFileType.DOCX}`,
  [EMimeType.PPTX]: `.${EFileType.PPTX}`,
  [EMimeType.PPSX]: `.${EFileType.PPSX}`,
  [EMimeType.JPEG]: `.${EFileType.JPEG}`,
  [EMimeType.PNG]: `.${EFileType.PNG}`,
  [EMimeType.ZIP]: `.${EFileType.ZIP}`,
  [EMimeType.HTML]: `.${EFileType.HTML}`,
};

export enum EScheduleJobStatus {
  SUCCESS = 'Success',
  PRE_QUEUED = 'Pre-queued',
  QUEUED = 'Queued',
  PENDING = 'Pending',
  CANCELED = 'Canceled',
  ERROR = 'Error',
}

export enum EDeliveryMethod {
  EMAIL = 'email',
  GMAIL = 'gmail',
  OFFICE365 = 'office365',
  SENDGRID = 'sendgrid',
  BREVO = 'brevo',
  DOWNLOAD = 'download',
  S3 = 's3',
  GOOGLE_DRIVE = 'google-drive',
  WEBHOOK = 'webhook',
  MICROSOFT_TEAMS = 'microsoft-teams',
  SLACK = 'slack',
  NOTIFICATION = 'notification',
  SHAREPOINT = 'sharepoint',
}

export enum ErrorCodes {}

export enum EScheduleAttachmentDownloadStatus {
  QUEUED = 'queued', // File is queued for generation
  IN_PROGRESS = 'in_progress', // File preparation
  GENERATED = 'generated', // File generated not ready to download (like in mail)
  DOWNLOADED = 'downloaded', // File downloaded
  EXPIRED = 'expired', // File expiration date is exceeded
  ERROR = 'error', // File not exist, error occurred
  CANCELED = 'canceled',
}

export enum EScheduleWorkflowStatus {
  QUEUED = 'queued', // File is queued for generation
  IN_PROGRESS = 'in_progress', // Workflow in progress
  SUCCESS = 'success', // Workflow execution success
  ERROR = 'error', // Workflow execution error
  CANCELED = 'canceled',
}
